var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.35476 0 0 3.35438 0 7.5C0 11.6452 3.35438 15 7.5 15C11.6452 15 15 11.6456 15 7.5C15 3.35481 11.6456 0 7.5 0ZM8.27019 10.4772C8.27019 10.7141 7.92466 10.951 7.50015 10.951C7.05589 10.951 6.74001 10.7141 6.74001 10.4772V6.71584C6.74001 6.43942 7.05592 6.25181 7.50015 6.25181C7.92466 6.25181 8.27019 6.43942 8.27019 6.71584V10.4772ZM7.50018 5.34363C7.04605 5.34363 6.69067 5.00798 6.69067 4.6328C6.69067 4.25766 7.04607 3.93187 7.50018 3.93187C7.94443 3.93187 8.29986 4.25766 8.29986 4.6328C8.29986 5.00798 7.9444 5.34363 7.50018 5.34363Z",
    fill: "#6045EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.1e2a0f2b5016f2b91e1948b1213725f0.svg";
export { ForwardRef as ReactComponent };